// レコメンドパーツ（widget）。分割後モデル: パーツ自身の表示定義のみを持つ。
// AB設定・配信コードは配信(recommendation_distributions)、設置先は widget_pages へ移動済み。
export const WidgetContentType = {
  PRODUCT: 'product',
  ARTICLE: 'article'
} as const

export type WidgetContentType = (typeof WidgetContentType)[keyof typeof WidgetContentType]

export const WidgetDisplayLogic = {
  BB: 'BB',
  OB: 'OB',
  PERSONAL: 'personal',
  SIMILAR: 'similar',
  MAIL: 'mail',
  ADAPTIVE: 'adaptive',
  RANKING_BLEND: 'ranking_blend',
  RECENTLY_VIEWED: 'recently_viewed',
  // 特集ページを起点に商品を返す（返すのは商品なので商品レコメンドに属する）
  RELATED_BY_ARTICLE: 'related_by_article',
  PERSONAL_BY_ARTICLE: 'personal_by_article',
  // 記事レコメンド
  ARTICLE_TRENDING: 'article_trending',
  ARTICLE_SIMILAR: 'article_similar',
  ARTICLE_PERSONAL: 'article_personal',
  ARTICLE_RELATED_BY_ITEM: 'article_related_by_item'
} as const

export type WidgetDisplayLogic = (typeof WidgetDisplayLogic)[keyof typeof WidgetDisplayLogic]

export const WidgetLayoutType = {
  GRID: 'grid',
  CAROUSEL: 'carousel',
  SLIDER: 'slider',
  LIST: 'list',
  // 主商品と併売候補を並べ、選んでまとめてカートに入れる表示（商品ID起点の商品ロジック・W2連動サイト限定）
  BUNDLE: 'bundle'
} as const

export type WidgetLayoutType = (typeof WidgetLayoutType)[keyof typeof WidgetLayoutType]

export const WidgetStatus = {
  ACTIVE: 'active', // 利用中
  INACTIVE: 'inactive', // 利用しない
  ARCHIVED: 'archived' // 廃止
} as const

export type WidgetStatus = (typeof WidgetStatus)[keyof typeof WidgetStatus]

export interface Widget {
  id: number
  site_id: number
  name: string
  display_logic: WidgetDisplayLogic
  display_logic_label: string
  content_type: WidgetContentType
  layout_type: WidgetLayoutType
  max_items: number
  title_template: string
  custom_css: string
  status: WidgetStatus
  widget_page_id: number | null
  created_at: string | null
  updated_at: string | null
}
